'use client'

import ShareLi from '@dg/common/components/Mobile/Common/Layerpopup/Share/ShareView/ShareLi/ShareLi'

export default ShareLi
